import React from "react";
import { Container, Grid } from "@mui/material";
import AnimationFadeIn from "@components/AnimationFadeIn";
import BackgroundImage from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import CardHomeCst from "@components/CardHomeCst";
import ButtonBackPage from "@components/ButtonBackPage";
import { useTranslation } from "react-i18next";

const SkillBook: React.FC = () => {
  const { t } = useTranslation(["skillBook-page"]);

  return (
    <AnimationFadeIn>
      <BackgroundImage
        customWidth="100%"
        customHeight="603px"
        image="section-skillbook.jpg"
        position="absolute"
        fullpage={true}
        zIndex={-1}
      />
      <Breadcrumb />
      <Container maxWidth="xxl" sx={{ position: "relative", zIndex: 1, mt: 2 }}>
        <HeroCst title={t("hero-title")} description={t("hero-description")} />
        <ButtonBackPage />
        <Grid container spacing={3} sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <CardHomeCst
              image="section-skillbook-esterna.jpg"
              title={t("card-title-enrollments")}
              description=""
              secondaryBtnLabel={t("manage")}
              to="enrollments"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <CardHomeCst
              image="section-skillbook-consuntivazione.jpg"
              title={t("card-title-completions")}
              description=""
              secondaryBtnLabel={t("manage")}
              to="completions"
            />
          </Grid>
        </Grid>
      </Container>
    </AnimationFadeIn>
  );
};

export default SkillBook;
